import request from "@/utils/request";
import qs from "qs";

export function getCouponList(params) {
  return request({ url: "/coupon/getTemplateList", method: "get", params });
}
export function saveCoupon(data) {
  return request.post("/coupon/editTemplate", qs.stringify(data));
}
export function updateCouponStatus(data) {
  return request.post("/coupon/updateTemplateStatus", qs.stringify(data));
}
export function deleteCoupon(data) {
  return request.post("/coupon/deleteTemplate", qs.stringify(data));
}
export function issueCoupon(data) {
  return request.post("/coupon/issueCoupon", qs.stringify(data));
}
export function getCouponRecords(params) {
  return request({ url: "/coupon/getUserCouponList", method: "get", params });
}
export function getCouponIssueRecords(params) {
  return request({ url: "/coupon/getIssueRecordList", method: "get", params });
}
